// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs";
import * as ActiveStorage from "@rails/activestorage";
import "channels";
import $ from "jquery";

import dayjs from "dayjs";
import axios from "axios";

Rails.start();
ActiveStorage.start();

window.addEventListener("load", () => {
  const ERROR_MESSAGE_STYLE = {
    color: "red",
    fontSize: ".6875rem",
    fontWeight: 300,
    lineHeight: 1.2,
    paddingTop: "5px",
  };

  /**
   * バリデータ群
   */
  const validators = [];
  validators["justLength"] = (target, targetName, len) => {
    if (target.length == len) {
      return true;
    }

    return `${targetName}の入力が未完了です。${targetName}を入力してください。`;
  };
  validators["dateFormat"] = (target, targetName) => {
    const DATE_FORMAT = "YYYY/MM/DD";

    if (dayjs(target, DATE_FORMAT).format(DATE_FORMAT) === target) {
      return true;
    }

    return `正しい${targetName}をYYYY/MM/DDで入力してください。`;
  };

  /**
   * エラーメッセージを表示します。
   * 対象の DOM に対して p タグを append し、p タグ内にエラーメッセージを
   * 表示します。
   */
  const appendErrorMessage = (targetElement, errorMessage) => {
    const messageElement = document.createElement("p");

    for (let key in ERROR_MESSAGE_STYLE) {
      messageElement.style[key] = ERROR_MESSAGE_STYLE[key];
    }
    messageElement.textContent = errorMessage;
    targetElement.appendChild(messageElement);
  };

  /**
   * エラーメッセージを削除します。
   * 対象の DOM 内の全ての p タグを削除し、エラーメッセージを削除します。
   */
  const deleteErrorMessage = (targetElement) => {
    const messageElements = targetElement.querySelectorAll("p");
    if (messageElements.length > 0) {
      messageElements.forEach((me) => {
        me.remove();
      });
    }
  };

  /**
   * 日付バリデーション用イベントハンドラ
   */
  document.querySelectorAll(".date-rule").forEach((dateElement) => {
    dateElement.addEventListener("input", (ev) => {
      const DATE_SEPARATOR = "/";
      const DATE_SEPARATE_INDEXES = [4, 7];

      const target = ev.target.value;
      // yyyy/mm/dd を入力する際に4桁目と7桁目を入力した際に、
      // 区切り文字の入力補助が行われる仕様。
      if (!!ev.data && DATE_SEPARATE_INDEXES.includes(target.length)) {
        ev.target.value += DATE_SEPARATOR;
      }

      deleteErrorMessage(ev.target.parentElement);

      let result = validators["justLength"](target, "日付", 10);
      if (true != result) {
        appendErrorMessage(ev.target.parentElement, result);
        return;
      }
      result = validators["dateFormat"](target, "日付");
      if (true != result) {
        appendErrorMessage(ev.target.parentElement, result);
        return;
      }
    });
  });
});

window.tsunagaru = {
  /**
   * アンケート回答ページの初期化処理を行います。
   * @param {Object} liff line liff
   */
  async init(liff) {
    const liffId = document.querySelector("#liff_id").value;

    liff
      .init({ liffId: liffId })
      .then(() => {
        this._initCheck(liff);
      })
      .catch((error) => {
        throw error;
      });
  },

  async _initCheck(liff) {
    // this._showDebugInfo(liff);

    const slug = document.querySelector("#slug").value;

    // 外部ブラウザはログイン確認を行う;
    if (!liff.isInClient()) {
      this._loginIfNeeded(liff, slug);
      return;
    }

    const isFriend = await this._isFriend(liff);
    // 友達でなければ、友達登録をさせる
    if (!isFriend) {
      this._goCancelPage(slug);
      return;
    }

    const limit = parseInt(document.querySelector("#application_limit_count").value);
    const lineOfficialId = document.querySelector("#line_official_account_id").value;
    const campaignId = document.querySelector("#campaign_id").value;

    const isLimit = await this._isAnswerLimit(liff, limit, lineOfficialId, campaignId);
    if (isLimit) {
      this._goAnswerdPage(slug);
    }
  },

  /**
   * toggleBranchesDisplay 系の補助関数。
   *
   * @param {string} str .questionnaireBranchIds フィールドの値
   * @returns {Array<number>} str を数値配列にパースしたもの
   */
  _parseQuestionnaireBranchIdsStr(str) {
    return !str
      ? []
      : str
        .split(",")
        .filter((strId) => strId !== "")
        .map((strId) => parseInt(strId));
  },

  /**
   *
   * @returns {Map<number, number>} `branchId->表示中かつ選択されている選択肢からbranchIdが分岐先指定されている数` のMap
   */
  _calcBranchUsedNumOnDisplayedSelectedChoice() {
    const questionnaireAnswerForm = document.getElementById("questionnaire_answer_form");
    // 表示中の設問一覧
    const questionnairesDisplayed = questionnaireAnswerForm.querySelectorAll(".questionnaire:not(.alert-invisible)");

    const branchUsedNumTable = new Map();
    for (const questionnaire of questionnairesDisplayed) {
      const control = questionnaire.querySelector(".control");
      // 「タイトル」や「画像」の場合スキップ
      if (!control) {
        continue;
      }

      let enabledBranchIds = [];
      // チェックボックスの場合
      if (control.classList.contains("questionnaire-checkbox")) {
        for (const textCheckbox of control.querySelectorAll(".text-checkbox")) {
          if (textCheckbox.checked) {
            const branchIds = this._parseQuestionnaireBranchIdsStr(textCheckbox.dataset.questionnaireBranchIds);
            enabledBranchIds.push(...branchIds);
          }
        }
      }
      // ラジオボタンの場合
      else if (control.classList.contains("questionnaire-radio")) {
        for (const radio of control.querySelectorAll("input[type='radio']")) {
          if (radio.checked) {
            const branchIds = this._parseQuestionnaireBranchIdsStr(radio.dataset.questionnaireBranchIds);
            enabledBranchIds.push(...branchIds);
          }
        }
      }
      // セレクトボックスの場合
      else if (control.querySelector(".select")) {
        const selectBox = control.querySelector("select");
        // 「選択してください」が選択されている場合を除外
        if (selectBox.selectedIndex !== 0) {
          const branchStrIds = selectBox.selectedOptions[0].dataset.questionnaireBranchIds;
          const branchIds = this._parseQuestionnaireBranchIdsStr(branchStrIds);
          enabledBranchIds.push(...branchIds);
        }
      }

      // branchIdsのbranchUsedNumTableへの登録
      for (const id of enabledBranchIds) {
        if (branchUsedNumTable.has(id)) {
          branchUsedNumTable.set(id, branchUsedNumTable.get(id) + 1);
        } else {
          branchUsedNumTable.set(id, 1);
        }
      }
    }

    return branchUsedNumTable;
  },

  /**
   * 設問内の選択肢から分岐する設問のID一覧を取得する。
   * 選択肢が選択されているかどうかは問わない。
   *
   * @param {HTMLElement} questionnaire 取得対象の設問
   * @returns {Array<number>} 分岐先設問IDの一覧
   */
  _takeAllBranchIdsOnQuestionnaire(questionnaire) {
    const allBranchIds = [];

    // チェックボックスの場合
    if (questionnaire.querySelector("input[type='checkbox']")) {
      for (const textCheckbox of questionnaire.querySelectorAll(".text-checkbox")) {
        const branchIds = this._parseQuestionnaireBranchIdsStr(textCheckbox.dataset.questionnaireBranchIds);
        allBranchIds.push(...branchIds);
      }
    }
    // ラジオボタンの場合
    else if (questionnaire.querySelector("input[type='radio']")) {
      for (const radio of questionnaire.querySelectorAll("input[type='radio']")) {
        const branchIds = this._parseQuestionnaireBranchIdsStr(radio.dataset.questionnaireBranchIds);
        allBranchIds.push(...branchIds);
      }
    }
    // セレクトボックスの場合
    else if (questionnaire.querySelector("select")) {
      const selectBox = questionnaire.querySelector("select").children;

      // 先頭は「選択してください」選択肢なので、２項目目から
      for (const choice of Array.from(selectBox).slice(1)) {
        const branchStrIds = choice.dataset.questionnaireBranchIds;
        const branchIds = this._parseQuestionnaireBranchIdsStr(branchStrIds);
        allBranchIds.push(...branchIds);
      }
    }

    return Array.from(new Set(allBranchIds));
  },

  /**
   * 設問内選択中の選択肢から分岐する設問IDの多重集合を取得する。
   * 設問が表示中かどうかは問わない。
   *
   * @param {number} questionnaireId 調査対象の設問ID
   * @returns {Array<number>} questionnaireId設問内で選択中の選択肢から分岐する設問IDの多重集合
   */
  _takeSelectedBranchIdsOnQuestionnaire(questionnaireId) {
    const questionnaire = document.getElementById(`questionnaire-${questionnaireId}`);

    const selectedBranchIds = [];

    // チェックボックスの場合
    if (questionnaire.querySelector("input[type='checkbox']")) {
      for (const textCheckbox of questionnaire.querySelectorAll(".text-checkbox")) {
        if (textCheckbox.checked) {
          const branchIds = this._parseQuestionnaireBranchIdsStr(textCheckbox.dataset.questionnaireBranchIds);
          selectedBranchIds.push(...branchIds);
        }
      }
    }
    // ラジオボタンの場合
    else if (questionnaire.querySelector("input[type='radio']")) {
      for (const radio of questionnaire.querySelectorAll("input[type='radio']")) {
        if (radio.checked) {
          const branchIds = this._parseQuestionnaireBranchIdsStr(radio.dataset.questionnaireBranchIds);
          selectedBranchIds.push(...branchIds);
        }
      }
    }
    // セレクトボックスの場合
    else if (questionnaire.querySelector("select")) {
      const selectBox = questionnaire.querySelector("select");
      // 「選択してください」が選択されている場合を除外
      if (selectBox.selectedIndex !== 0) {
        const branchStrIds = selectBox.selectedOptions[0].dataset.questionnaireBranchIds;
        const branchIds = this._parseQuestionnaireBranchIdsStr(branchStrIds);
        selectedBranchIds.push(...branchIds);
      }
    }

    return selectedBranchIds;
  },

  /**
   * toggleBranchesDisplay の補助関数。
   * branchUsedNumTable の情報をもとに、branchIdの設問の表示/非表示を切り替える
   * branchUsedNumTable の更新も合わせて行う。
   *
   * @param {number} branchId 切り替え対象の設問ID
   * @param {Map<number, number>} branchUsedNumTable `branchId->表示中かつ選択されている選択肢からbranchIdが分岐先指定されている数` のMap
   */
  _toggleBranchElemDisplay(branchId, branchUsedNumTable) {
    const targetFormType = [
      "input[type='text']",
      "input[type='tel']",
      "input[type='date']",
      "textarea",
      "input[type='checkbox']",
      "select",
      "input[type='radio']",
    ];

    const branchElem = document.getElementById(`questionnaire-${branchId}`);
    const formElems = branchElem.querySelectorAll(targetFormType.join(","));

    // branchIdが表示対象
    if (branchUsedNumTable.has(branchId) && branchUsedNumTable.get(branchId) > 0) {
      if (branchElem.classList.contains("alert-invisible")) {
        // branchUsedNumTable の更新
        for (const id of this._takeSelectedBranchIdsOnQuestionnaire(branchId)) {
          if (branchUsedNumTable.has(id)) {
            branchUsedNumTable.set(id, branchUsedNumTable.get(id) + 1);
          } else {
            branchUsedNumTable.set(id, 1);
          }
        }

        // HTML要素の更新
        branchElem.classList.remove("alert-invisible");
        for (const e of formElems) {
          e.required = e.dataset.isRequired == "true";
          e.disabled = false;
        }
      }
    }
    // branchIdが非表示対象
    else {
      if (!branchElem.classList.contains("alert-invisible")) {
        // branchUsedNumTable の更新
        for (const id of this._takeSelectedBranchIdsOnQuestionnaire(branchId)) {
          branchUsedNumTable.set(id, branchUsedNumTable.get(id) - 1);
        }

        // HTML要素の更新
        branchElem.classList.add("alert-invisible");
        for (const e of formElems) {
          e.required = false;
          e.disabled = true;
        }
      }
    }
  },

  /**
   * 分岐設問の表示/非表示を切り替えます。
   *
   * 表示対象設問かどうかは data-questionnaire-id 要素の値を取得して判定します。
   *
   * @param {Number} questionnaireId 操作された設問ID。表示/非表示の切り替えはこの設問以降のみに対して行う(処理コスト削減のため)。空の場合は全設問を処理対象にする(submit時のチェック用)。
   */
  toggleBranchesDisplay(questionnaireId) {
    const questionnaireAnswerForm = document.getElementById("questionnaire_answer_form");
    // 設問一覧
    const questionnaires = Array.from(questionnaireAnswerForm.querySelectorAll(".questionnaire"));
    const startIndex = questionnaireId
      ? questionnaires.findIndex((q) => parseInt(q.dataset.questionnaireId) === questionnaireId)
      : 0;

    // 各設問が、有効な選択肢から何回分岐指定されているかのMap
    const branchUsedNumTable = this._calcBranchUsedNumOnDisplayedSelectedChoice();

    // qの選択肢の選択状況とq自体の表示/非表示の情報に応じて切り替える
    // 推移的な分岐に対応するために、questionnaireId 以降の全ての設問を見直す
    for (const q of questionnaires.slice(startIndex)) {
      const allBranchIdsOnQuestionnaire = this._takeAllBranchIdsOnQuestionnaire(q);

      for (const branchId of allBranchIdsOnQuestionnaire) {
        this._toggleBranchElemDisplay(branchId, branchUsedNumTable);
      }
    }
  },

  /**
   * アンケート提出時のバリデーションチェック用の関数
   * 表示中の必須設問が全て入力されているか確認し、されていない設問に警告文を出す
   *
   * @returns {boolean} バリデーションチェックの成否
   */
  validateQuestionnaireSubmission() {
    /**
     * チェックボックスのバリデーション
     * 必須のものがチェックされているか確認しています
     * チェックされていない場合はエラー文を表示させ、送信させません
     *
     * 必須チェックされていなければエラーにしません
     * 画面に表示されていなければエラーにしません
     */
    let errorEls = [];
    let checkboxError = false;
    const checkBoxEls = $(".questionnaire-checkbox,.questionnaire-checkbox-image");
    checkBoxEls.map((i, checkboxEl) => {
      const alertEl = $(checkboxEl).find(".questionnaire-checkbox-alert");
      alertEl.addClass("alert-invisible"); // 一旦全てのエラー文を非表示にする

      const isRequired = checkboxEl.dataset.required;

      if (isRequired == "false") return;
      const isDisabled = $(checkboxEl).parents(".questionnaire.alert-invisible").length > 0;
      if (isDisabled) return;

      const checkedEls = $(checkboxEl).find("input[type=checkbox]:checked");
      const isChecked = checkedEls.length > 0;
      if (!isChecked) {
        checkboxError = true;
        errorEls.push(checkboxEl);
        alertEl.removeClass("alert-invisible");
      }
    });

    /**
     * ラジオボタンのバリデーション
     * 必須のものがチェックされているか確認しています
     * チェックされていない場合はエラー文を表示させ、送信させません
     *
     * 必須チェック(*)されていなければエラーにしません
     * 画面に表示されていなければエラーにしません
     */
    let radioError = false;
    const radioEls = $(".questionnaire-radio,.questionnaire-radio-image");
    radioEls.map((i, radioEl) => {
      const alertEl = $(radioEl).find(".questionnaire-radio-alert");
      alertEl.addClass("alert-invisible"); // 一旦全てのエラー文を非表示にする

      const isRequired = radioEl.dataset.required;
      if (isRequired == "false") return;
      const isDisabled = $(radioEl).parents(".questionnaire.alert-invisible").length > 0;
      if (isDisabled) return;

      const checkedEls = $(radioEl).find("input[type=radio]:checked");
      const isChecked = checkedEls.length > 0;
      if (!isChecked) {
        radioError = true;
        errorEls.push(radioEl);
        alertEl.removeClass("alert-invisible");
      }
    });

    /**
     * プルダウンのバリデーション
     * 必須のものがチェックされているか確認しています
     * チェックされていない場合はエラー文を表示させ、送信させません
     *
     * 必須チェックされていなければエラーにしません
     * 画面に表示されていなければエラーにしません
     */
    let pullDownError = false;
    const pullDownEls = $(".questionnaire-selectbox");
    pullDownEls.map((i, pullDownEl) => {
      const alertEl = $(pullDownEl).find(".questionnaire-selectbox-alert");
      alertEl.addClass("alert-invisible"); // 一旦全てのエラー文を非表示にする

      const selectEl = pullDownEl.querySelector("select");

      const isRequired = selectEl.dataset.isRequired;
      if (isRequired == "false") return;
      const isDisabled = $(pullDownEl).parents(".questionnaire.alert-invisible").length > 0;
      if (isDisabled) return;

      const isChecked = selectEl.selectedIndex > 0;
      if (!isChecked) {
        pullDownError = true;
        errorEls.push(pullDownEl);
        alertEl.removeClass("alert-invisible");
      }
    });

    if (checkboxError || radioError || pullDownError) {
      // ページの一番上にあるエラーに移動する
      const topErrorEl = errorEls.sort((a, b) => a.offsetTop - b.offsetTop)[0];
      const rect = topErrorEl.getBoundingClientRect();
      scrollTo(0, rect.top + window.pageYOffset);
      return false;
    }

    // eslint-disable-next-line no-undef
    const accessToken = liff.getAccessToken();
    $("#line_access_token").val(accessToken);
    return true;
  },

  _loginIfNeeded(liff, slug) {
    if (liff.isLoggedIn()) {
      return;
    }

    liff.login({
      redirectUri: `https://${location.host}/userpage/questionnaires/new/${slug}`,
    });
  },

  /**
   * 回答済ページに遷移します。
   * @param {String} slug
   */
  _goAnswerdPage(slug) {
    location.href = `/userpage/questionnaires/answered/${slug}`;
  },

  /**
   * キャンセルページに遷移します。
   * @param {String} slug
   */
  _goCancelPage(slug) {
    location.href = `/userpage/questionnaires/cancel/${slug}`;
  },

  /**
   *
   * @param {Event} ev イベントオブジェクト
   */
  _appendSeparateForDateStr(ev) {
    const DATE_SEPARATOR = "/";
    const DATE_SEPARATE_INDEXES = [4, 7];

    const target = ev.target.value;
    // yyyy/mm/dd を入力する際に4桁目と7桁目を入力した際に、
    // 区切り文字の入力補助が行われる仕様。
    if (!!ev.data && DATE_SEPARATE_INDEXES.includes(target.length)) {
      ev.target.value += DATE_SEPARATOR;
    }
  },

  /**
   * 友達かどうかを判定します。
   * @param {Object} liff line liff
   * @returns {Boolean} 友達判定
   */
  async _isFriend(liff) {
    try {
      const response = await liff.getFriendship();

      return response.friendFlag;
    } catch (error) {
      console.error(error);

      return false;
    }
  },

  /**
   * アンケート回数制限に到達しているか判定します。
   * @param {Object} liff line liff
   * @returns {Boolean} 制限判定
   */
  async _isAnswerLimit(liff, limit, lineOfficialId, campaignId) {
    if (limit === 0) {
      return false;
    }

    const endpoint = "/api/contents/questionnaires/answer_limit_check";
    const payload = {
      token: liff.getAccessToken(),
      line_official_account_id: lineOfficialId,
      campaign_id: campaignId,
    };
    try {
      const response = await axios.post(endpoint, payload);
      const status = response.data.status;

      if (status == "not_answered") {
        return false;
      }

      return true;
    } catch (error) {
      alert(error);

      return true;
    }
  },

  _showDebugInfo(liff) {
    window.alert(`
      LIFF ver: ${liff.getVersion()}
      LINE ver: ${liff.getLineVersion()} ※nullは外部ブラウザ
      ログイン: ${liff.isLoggedIn() ? "している" : "していない"}
      LIFF ブラウザ: ${liff.isInClient() ? "LIFFブラウザ" : "外部ブラウザ"}
      .getContext()
      ${JSON.stringify(liff.getContext())}
      `);
  },
};
